import { gsap, ScrollTrigger } from './global/gsap';

const media = document.querySelectorAll('.js-edition-media');
const details = Array.from(document.querySelectorAll('.js-edition-detail'));

media.forEach((item) => {
    const edition = item.dataset.editionCount;
    const detail = details.filter((item) => item.dataset.editionCount === edition);
    const logoNum = detail[0].querySelector('.logo-number');
    const start = 'top 50%';
    const end = 'bottom 50%';

    gsap.defaults({
        ease: 'power3.inOut'
    })

    gsap.set(logoNum, {yPercent: -60, opacity: 0})
    
    ScrollTrigger.create({
        trigger: item,
        start,
        end,
        invalidateOnRefresh: true,
        onEnter: () => {
            gsap.to(logoNum, { yPercent: 0, opacity: 1})
        },
        onEnterBack: () => {
            gsap.to(logoNum, { yPercent: 0, opacity: 1})
        },
        onLeave: () => {
            gsap.to(logoNum, {yPercent: 60, opacity: 0});
            
        },
        onLeaveBack: () => {
            gsap.to(logoNum, {yPercent: -60, opacity: 0});
        },
        onUpdate: (self) => {
            details.forEach((detail) => {
                detail.classList.remove('edition-active');

                if (self.trigger.dataset.editionCount === detail.dataset.editionCount) {
                    detail.classList.add('edition-active');
                }
            });
        }
    });
});
